import cn from 'classnames';

import DELAY from 'constants/delay.const';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import { useTheme } from 'providers/Theme.provider';
import { isEnvMobile } from 'utils/env/determine.util';
import delayed from 'utils/functions/delayed.util';

import CN from './Tooltip.module.scss';

const Tooltip = ({ variant, children, content, custom, position, width }) => {
  const { isDarkMode } = useTheme();
  const isMobile = isEnvMobile({ regex: true });

  const componentClasses = cn({
    [CN.tooltip]: true,
    [CN[`${variant}Variant`]]: variant,
    [CN[`${position}Position`]]: position,
    [CN[`${width}Width`]]: width,
    [CN.custom]: custom,
    [CN.dark]: isDarkMode,
  });

  let timeout;
  const [active, setActive] = useStateWhileMounted(false);

  const showTip = () => {
    timeout = delayed(DELAY.fast, () => void setActive(true));
  };

  const hideTip = () => {
    clearTimeout(timeout);
    setActive(false);
  };

  const handleToggle = () => {
    if (active) {
      hideTip();
    } else {
      showTip();
    }
  };

  return (
    <div
      data-bem="Tooltip"
      className={CN.wrapper}
      {...(!isMobile && { onMouseEnter: showTip, onMouseLeave: hideTip })} // Desktop -> use hover (onMouseEnter/onMouseLeave)
      {...(isMobile && { onClick: handleToggle })} // Mobile -> use tap (onClick)
    >
      {children}
      {active && content && (
        <div className={componentClasses} data-bem="Tooltip__content">
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
